import {DataType} from '@wix/editor-platform-ooi-metadata-resolver';
import {createSettingsParam, createSettingsParams, SettingsParamType} from '@wix/tpa-settings';
import {createBuilderTextMetadata} from '@wix/wixstores-client-storefront-common';

/* istanbul ignore file: not being actually used */
export type TextSettingsParams = keyof typeof settingsParams;
export type ISettingsParams = Record<TextSettingsParams, (typeof settingsParams)[TextSettingsParams]['type']>;

const settingsParams = {
  LOAD_MORE_BUTTON: createSettingsParam('LOAD_MORE_BUTTON', {
    type: SettingsParamType.Text,
    getDefaultValue: () => null,
    metadata: createBuilderTextMetadata('LOAD_MORE_BUTTON'),
  }),
  gallery_loadPreviousText: createSettingsParam('gallery_loadPreviousText', {
    type: SettingsParamType.Text,
    getDefaultValue: () => null,
    metadata: createBuilderTextMetadata('gallery.loadPrevious.button'),
  }),
  gallery_oosButtonText: createSettingsParam('gallery_oosButtonText', {
    type: SettingsParamType.Text,
    getDefaultValue: () => null,
    metadata: createBuilderTextMetadata('gallery.outOfStock.button'),
  }),
  gallery_addToCartText: createSettingsParam('gallery_addToCartText', {
    type: SettingsParamType.Text,
    getDefaultValue: () => null,
    metadata: createBuilderTextMetadata('gallery.addToCart.button'),
  }),
  gallery_preOrderText: createSettingsParam('gallery_preOrderText', {
    type: SettingsParamType.Text,
    getDefaultValue: () => null,
    metadata: createBuilderTextMetadata('gallery.preOrder.button'),
  }),
  FILTERS_MAIN_TITLE: createSettingsParam('FILTERS_MAIN_TITLE', {
    type: SettingsParamType.Text,
    getDefaultValue: () => null,
    metadata: createBuilderTextMetadata('filter.MAIN_TITLE'),
  }),
  SORTING_MAIN_TITLE: createSettingsParam('SORTING_MAIN_TITLE', {
    type: SettingsParamType.Text,
    getDefaultValue: () => null,
    metadata: createBuilderTextMetadata('SORT_BY'),
  }),
  categoryTreeTitle: createSettingsParam('categoryTreeTitle', {
    type: SettingsParamType.Text,
    getDefaultValue: () => null,
    metadata: createBuilderTextMetadata('gallery.categories.title.defaultText'),
  }),
  gallery_filtersAndSortMobileButtonText: createSettingsParam('gallery_filtersAndSortMobileButtonText', {
    type: SettingsParamType.Text,
    getDefaultValue: () => null,
    metadata: createBuilderTextMetadata('gallery.mobile.filterAndSort.defaultText'),
  }),
  quickView_addToCartButton: createSettingsParam('quickView_addToCartButton', {
    type: SettingsParamType.Text,
    getDefaultValue: () => null,
    metadata: createBuilderTextMetadata('gallery.quickView.addToCartButton.defaultText'),
  }),
  gallery_titleText: createSettingsParam('gallery_titleText', {
    type: SettingsParamType.Text,
    getDefaultValue: () => null,
    metadata: createBuilderTextMetadata('wishlist.title.defaultText'),
  }),
  gallery_subtitleText: createSettingsParam('gallery_subtitleText', {
    type: SettingsParamType.Text,
    getDefaultValue: () => null,
    metadata: createBuilderTextMetadata('wishlist.subtitle.defaultText'),
  }),
  gallery_noProductsMessage: createSettingsParam('gallery_noProductsMessage', {
    type: SettingsParamType.Text,
    getDefaultValue: () => null,
    metadata: createBuilderTextMetadata('wishlist.emptyState.message.defaultText'),
  }),
  gallery_emptyStateLink: createSettingsParam('gallery_emptyStateLink', {
    type: SettingsParamType.Text,
    getDefaultValue: () => null,
    metadata: createBuilderTextMetadata('wishlist.emptyState.link.defaultText'),
  }),
  SLIDER_GALLERY_TITLE_COLLECTION: createSettingsParam('SLIDER_GALLERY_TITLE_COLLECTION', {
    type: SettingsParamType.Text,
    getDefaultValue: () => null,
    metadata: createBuilderTextMetadata('gallery.sliderGallery.title.collection.defaultText'),
  }),
  gallery_selectOptionsButtonText: createSettingsParam('gallery_selectOptionsButtonText', {
    type: SettingsParamType.Text,
    getDefaultValue: () => null,
    metadata: createBuilderTextMetadata('gallery.selectOptions.button'),
  }),
  gallery_categoryFooterDescriptionShowMoreButtonText: createSettingsParam(
    'gallery_categoryFooterDescriptionShowMoreButtonText',
    {
      type: SettingsParamType.Text,
      getDefaultValue: () => null,
      metadata: createBuilderTextMetadata('categoryPage.footerDescription.showMore.button'),
    }
  ),
  gallery_categoryFooterDescriptionShowLessButtonText: createSettingsParam(
    'gallery_categoryFooterDescriptionShowLessButtonText',
    {
      type: SettingsParamType.Text,
      getDefaultValue: () => null,
      metadata: createBuilderTextMetadata('categoryPage.footerDescription.showLess.button'),
    }
  ),
  'category-page-list-top': createSettingsParam('category-page-list-top', {
    type: SettingsParamType.Object,
    getDefaultValue: () => null,
    metadata: {
      type: DataType.container,
      defaultValue: {
        type: 'static',
        value: {},
      },
      dataItemManifestData: {
        container: {
          containerType: 'slot',
          slot: {
            slotId: 'category-page-list-top',
          },
        },
      },
    },
  }),
  'product-gallery-details-slot-1': createSettingsParam('product-gallery-details-slot-1', {
    type: SettingsParamType.Object,
    getDefaultValue: () => null,
    metadata: {
      type: DataType.container,
      defaultValue: {
        type: 'static',
        value: {},
      },
      dataItemManifestData: {
        container: {
          containerType: 'slot',
          slot: {
            slotId: 'product-gallery-details-slot-1',
          },
        },
      },
    },
  }),
  'category-page-hero-top': createSettingsParam('category-page-hero-top', {
    type: SettingsParamType.Object,
    getDefaultValue: () => null,
    metadata: {
      type: DataType.container,
      defaultValue: {
        type: 'static',
        value: {},
      },
      dataItemManifestData: {
        container: {
          containerType: 'slot',
          slot: {
            slotId: 'category-page-hero-top',
          },
        },
      },
    },
  }),
  'gallery-filters-top': createSettingsParam('gallery-filters-top', {
    type: SettingsParamType.Object,
    getDefaultValue: () => null,
    metadata: {
      type: DataType.container,
      defaultValue: {
        type: 'static',
        value: {},
      },
      dataItemManifestData: {
        container: {
          containerType: 'slot',
          slot: {
            slotId: 'gallery-filters-top',
          },
        },
      },
    },
  }),
  'gallery-filters-bottom': createSettingsParam('gallery-filters-bottom', {
    type: SettingsParamType.Object,
    getDefaultValue: () => null,
    metadata: {
      type: DataType.container,
      defaultValue: {
        type: 'static',
        value: {},
      },
      dataItemManifestData: {
        container: {
          containerType: 'slot',
          slot: {
            slotId: 'gallery-filters-bottom',
          },
        },
      },
    },
  }),
  'category-page-hero-bottom': createSettingsParam('category-page-hero-bottom', {
    type: SettingsParamType.Object,
    getDefaultValue: () => null,
    metadata: {
      type: DataType.container,
      defaultValue: {
        type: 'static',
        value: {},
      },
      dataItemManifestData: {
        container: {
          containerType: 'slot',
          slot: {
            slotId: 'category-page-hero-bottom',
          },
        },
      },
    },
  }),
  'gallery-products-top': createSettingsParam('gallery-products-top', {
    type: SettingsParamType.Object,
    getDefaultValue: () => null,
    metadata: {
      type: DataType.container,
      defaultValue: {
        type: 'static',
        value: {},
      },
      dataItemManifestData: {
        container: {
          containerType: 'slot',
          slot: {
            slotId: 'gallery-products-top',
          },
        },
      },
    },
  }),
  'gallery-products-bottom': createSettingsParam('gallery-products-bottom', {
    type: SettingsParamType.Object,
    getDefaultValue: () => null,
    metadata: {
      type: DataType.container,
      defaultValue: {
        type: 'static',
        value: {},
      },
      dataItemManifestData: {
        container: {
          containerType: 'slot',
          slot: {
            slotId: 'gallery-products-bottom',
          },
        },
      },
    },
  }),
};

export default createSettingsParams<ISettingsParams>(settingsParams);
